import { FC, useId, useRef, useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { LucideIcon, LucideProps } from "lucide-react";

import { PropsWithClassNameI } from "shared/lib/interfaces/ui";

interface LucideIconWithGradientPropsI
  extends LucideProps, PropsWithClassNameI {
  icon: LucideIcon;
  startColor: string;
  stopColor: string;
}

type GenericLucideIconWithGradientPropsI = Omit<
  LucideIconWithGradientPropsI,
  "startColor" | "stopColor"
>;

export const LucideIconWithGradient = ({
  icon: Icon,
  startColor,
  stopColor,
  size = 24,
  className,
  ...rest
}: LucideIconWithGradientPropsI) => {
  const iconRef = useRef<SVGSVGElement | null>(null);
  const gradientId = `lucideGradient-${useId().replace(/:/g, "")}`;
  const [target, setTarget] = useState<SVGSVGElement | null>(null);

  useEffect(() => {
    if (iconRef.current) {
      setTarget(iconRef.current);
    }
  }, [gradientId]);

  return (
    <>
      <Icon
        ref={iconRef}
        {...rest}
        size={size}
        stroke={`url(#${gradientId})`}
        className={className}
      />

      {target &&
        createPortal(
          <defs>
            <linearGradient id={gradientId} gradientUnits="userSpaceOnUse">
              <stop offset="0%" stopColor={startColor} />
              <stop offset="100%" stopColor={stopColor} />
            </linearGradient>
          </defs>,
          target
        )}
    </>
  );
};

export const LucideIconWithAIGradient: FC<
  GenericLucideIconWithGradientPropsI
> = (props) => (
  <LucideIconWithGradient {...props} startColor="#ff00cc" stopColor="#3333ff" />
);
